<template>
  <div
    class="row-wrap"
  >
    <v-menu
      v-model="menuOpen"
      top
      offset-y
      :close-on-content-click="false"
      :nudge-top="6"
    >
      <template
        #activator="{ on, attrs }"
      >
        <v-btn
          fab
          small
          :color="btnColor"
          v-bind="attrs"
          class="palette-btn"
          v-on="on"
          elevation="0"
        >
          <v-icon
            small
            color="white"
          >
            mdi-palette
          </v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-color-picker
          v-model="colorProxy"
          light
          dot-size="25"
          hide-inputs
        />
      </v-card>
    </v-menu>

    <v-select
      class="line-select"
      dark
      :value="lineSelected"
      :items="lines"
      hide-details
      dense
      outlined
      return-object
      :menu-props="{ top: true, offsetY: true, auto: false }"
      style="background-color: #FFFFFF55;"
      @input="$emit('update:lineSelected', $event)"
    >
      <template
        #selection="{ item }"
      >
        <img
          :src="item.img"
          :height="previewHeight"
          :width="previewWidth"
          class="line-preview"
        >
      </template>
      <template
        #item="{ item }"
      >
        <img
          :src="item.img"
          :height="previewHeight"
          :width="previewWidth"
          class="line-preview"
        >
      </template>
    </v-select>

    <v-tooltip
      bottom
    >
      <template
        #activator="{ on, attrs }"
      >
        <v-btn
          fab
          small
          color="primaryLight"
          v-bind="attrs"
          :class="{ activeBTN: activeKey === `${drawEvent}Button` }"
          v-on="on"
          elevation="0"
          @click="$emit('draw', drawEvent)"
        >
          <v-icon
            small
            color="white"
          >
            {{ drawIcon }}
          </v-icon>
        </v-btn>
      </template>
      <span>{{ drawTooltip }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'SymbologyColorLineRow',
  props: {
    lines: { type: Array, default: () => [] },
    lineSelected: { type: [Object, null], default: null },
    colorSelected: { type: Object, required: true },
    activeKey: { type: [String, null], default: null },
    assetBasePath: { type: String, default: 'simbologia_v3' },
    previewHeight: { type: [Number, String], default: 12 },
    previewWidth: { type: [Number, String], default: 110 },

    drawEvent: { type: String, default: 'polyline' },
    drawIcon: { type: String, default: 'mdi-vector-polyline' },
    drawTooltip: { type: String, default: 'Trazar línea' }
  },

  data: () => ({
    menuOpen: false
  }),

  computed: {
    colorProxy: {
      get() { return this.colorSelected },
      set(v) { this.$emit('update:colorSelected', v) }
    },
    btnColor() {
      return this.colorSelected?.hex || 'primaryLight'
    }
  }
}
</script>

<style scoped>
.row-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px 6px 12px;
}

.palette-btn {
  flex: 0 0 auto;
}

.line-select {
  flex: 1 1 auto;
}

.line-preview {
  object-fit: contain;
  display: block;
}

.activeBTN {
  border: 2px solid rgb(255, 255, 255);
  border-radius: 999px;
}
</style>
